import { Box, Container, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import AddUser from "@/pages/utilities/settings/components/UserManagement/AddUser/AddUser";
import UserManagement from "@/pages/utilities/settings/components/UserManagement/UserManagement";
import { paths } from "@/routes/paths";

interface TabPanelProps {
  children?: React.ReactNode;
}

function NoPaddingTabPanel({ children }: TabPanelProps) {
  return <Box sx={{ p: 0 }}>{children}</Box>;
}

const Settings = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container
      sx={{
        px: location.pathname.startsWith(paths.utilities.userManagement)
          ? 0
          : { xs: 0, sm: 1, md: 2 },
      }}
      disableGutters={isMobile || location.pathname.startsWith(paths.utilities.userManagement)}
      maxWidth={location.pathname.startsWith(paths.utilities.userManagement) ? false : "lg"}
    >
      <Box sx={{ width: "100%" }}>
        <Routes>
          <Route
            path="/"
            element={
              <NoPaddingTabPanel>
                <UserManagement />
              </NoPaddingTabPanel>
            }
          />
          <Route
            path="new"
            element={
              <NoPaddingTabPanel>
                <AddUser />
              </NoPaddingTabPanel>
            }
          />
          <Route
            path="edit/:userId"
            element={
              <NoPaddingTabPanel>
                <AddUser mode="edit" />
              </NoPaddingTabPanel>
            }
          />
        </Routes>
      </Box>
    </Container>
  );
};

export default Settings;
